<template >
    <div>
        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            :absolute="true"
            size="64"
        ></v-progress-circular>
        </v-overlay>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6">
            <h1 class="display-1 font-weight-bold color-title font-title"><i>Grupo Innofarm</i></h1>
            <h1 class="font-size-custom font-weight-bold color-title font-title"><i>SUS DATOS PERSONALES</i></h1>
        </div>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-8 font-text">
            <v-expansion-panels focusable>
                <v-expansion-panel class="mb-4">
                    <v-expansion-panel-header color="#5cc397" class="white--text"> <div><v-icon class="white--text">mdi-account-settings</v-icon> Datos y accesos</div></v-expansion-panel-header>
                    <v-expansion-panel-content >   
                        <v-form ref="form_access_account">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="userAccount"
                                        label="Usuario (Inicio de sesión en la web)"
                                        type="text"
                                        :rules=requiredRule
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="password"
                                        label="Contraseña"
                                        prepend-inner-icon="mdi-key-variant"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show = !show"
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="firstName"
                                        label="Nombres"
                                        type="text"
                                        :rules=requiredRule
                                        prepend-inner-icon="mdi-account-outline"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="lastName"
                                        label="Apellidos"
                                        type="text"
                                        :rules=requiredRule
                                        prepend-inner-icon="mdi-account-outline"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="identification"
                                        label="identificacion"
                                        type="text"
                                        :rules=requiredRule
                                        prepend-inner-icon="mdi-account-outline"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-col  class="text-center">
                                <v-btn 
                                    color="primary" 
                                    :loading=loadingBtn
                                    class="text-center"
                                    @click="updateAccess"
                                >
                                    <v-icon>mdi-floppy</v-icon> GUARDAR   
                                </v-btn>
                            </v-col>
                        </v-form>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="mb-4">
                    <v-expansion-panel-header 
                        color="#5cc397" 
                        class="white--text"
                    >
                        <div>
                            <v-icon class="white--text">mdi-directions</v-icon> Direcciones de entrega
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-col cols="12" class="px-0">
                            <v-btn color="primary" @click="addDirection">
                                <v-icon>mdi-plus</v-icon> Nueva dirección   
                            </v-btn>
                        </v-col>
                        <div v-if="!!directions.length" > 
                            <v-card 
                                v-for="(direction, x) in this.directions"
                                class="d-flex align-center justify-space-between py-3 px-2 my-2"
                                elevation="2"
                                :key="x"
                            >
                                <div>
                                    <b>{{x+1}})</b> {{ direction.direction }}
                                    <div class="caption">
                                        <em class="pl-5">{{ direction.observaciones }}</em>
                                    </div>
                                </div>
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                fab
                                                x-small
                                                color="warning"
                                                class="white--text mx-1"
                                                v-bind="attrs"
                                                v-on="on" 
                                                @click="editDirection(direction)"
                                            > 
                                            <v-icon>mdi-pencil</v-icon> 
                                            </v-btn>
                                        </template>
                                        <span>Editar dirección</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                fab
                                                x-small
                                                color="red"
                                                class="white--text mx-1"
                                                v-bind="attrs"
                                                v-on="on" 
                                                @click="deleteDirection(direction)"
                                            > 
                                                <v-icon>mdi-delete</v-icon> 
                                            </v-btn>
                                        </template>
                                        <span>Eliminar dirección</span>
                                    </v-tooltip>
                                </div>
                            </v-card>
                        </div>
                        <v-col v-else>
                            <v-alert
                                border="right"
                                colored-border
                                type="error"
                                elevation="2"
                            >
                                No tiene direcciones guardados
                            </v-alert>
                        </v-col>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="mb-4">
                    <v-expansion-panel-header color="#5cc397" class="white--text">
                        <div>
                            <v-icon  class="white--text">mdi-cellphone</v-icon> Teléfonos de contacto
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-col cols="12" class="px-0">
                            <v-btn color="primary" @click="addPhone">
                                <v-icon>mdi-plus</v-icon> Nuevo Teléfono   
                            </v-btn>
                        </v-col>
                        <div v-if="!!phones.length" >
                            <v-row>
                                <v-form 
                                    ref="form_phone"
                                    v-for="(phone, x) in phones" 
                                    :key="x"
                                    class="col-md-4 col-12 d-flex align-center"
                                >
                                    <v-text-field-simplemask
                                        v-model="phones[x].phone"
                                        label="Escriba el telefono"
                                        :properties="{
                                            prefix: '',
                                            suffix: '',
                                            readonly: false,
                                            disabled: false,
                                            outlined: false,
                                            clearable: true,
                                            placeholder: '(000) 000-00-00',
                                            rules: requiredRule
                                        }"
                                        :options="{
                                            inputMask: '(###) ###-##-##',
                                            outputMask: '###########',
                                            empty: null,
                                            applyAfter: false,
                                            alphanumeric: false,
                                            lowerCase: false,
                                        }"
                                    />
                                    <v-tooltip bottom >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                fab 
                                                x-small 
                                                color="red"
                                                class="white--text"
                                                v-bind="attrs"
                                                v-on="on" 
                                                @click="deletePhones(phone)"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar teléfono</span>
                                    </v-tooltip>
                                </v-form>
                            </v-row>
                        </div>
                        <v-col v-else>
                            <v-alert
                                border="right"
                                colored-border
                                type="error"
                                elevation="2"
                            >
                                No tiene teléfonos guardados
                            </v-alert>
                        </v-col>
                        <v-col  class="text-center">
                            <v-btn 
                                color="primary" 
                                :loading=loadingBtn
                                class="text-center"
                                @click="storePhones"
                            >
                                <v-icon>mdi-floppy</v-icon> GUARDAR   
                            </v-btn>
                        </v-col>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <v-dialog 
            v-model="dialogNewDirection" 
            max-width="1000px"
            persistent
        >   
            <div style="background: white;">
                <CaptureDirection 
                    v-if="dialogNewDirection"
                    :dataDirection=dataDirection
                    @close="closeModalDirection" 
                    @storeDirection="storeDirection" 
                />
            </div>
        </v-dialog>
    </div>
</template>

<script>

    import { mapActions, mapMutations, mapState } from 'vuex'
    import CaptureDirection from '../partials/CaptureDirectionComponent.vue'
    import Vue from 'vue'

    export default{
        name: 'CustomerPersonalInformation',
        components:{
            CaptureDirection
        },
        data: () => ({
            userAccount: null,
            show: false,
            identification: null,
            oldUserAccount:null,
            password :null,
            email: null,
            firstName:null,
            lastName:null,
            overlay:false,
            dialogNewDirection:false,
            contactMechDirectionId:null,
            dataDirection:{},
            phones:[],
            directions:[],
            requiredRule: [
                v => !!v || 'El campo es requerido'
            ],
            emailRule: [
                v => !!v || 'El correo es requerido',
                v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Escriba un correo válido'
            ]
        }),
            computed:{
            ...mapState(['loadingBtn','user','paramAlertQuestion'])
        },
        methods: {
            
            ...mapActions(['requestApi','alertNotification','checkSessionStatus']),

            ...mapMutations(['setUrl','setLoadingBtn']),

            getDataCustomer(){

                this.setUrl('buscar-cliente');
                this.requestApi({
                    method: 'GET',
                    data: {
                        partyId : this.user.party_id
                    }

                }).then(res=>{
                    console.log(res)

                    const { user_ligin_id, identification } = this.user
                    const { first_name, last_name, phones, directions} = res.data._embedded.buscar_cliente[0]

                    this.userAccount = user_ligin_id
                    this.oldUserAccount = user_ligin_id
                    this.identification = identification
                    this.firstName = first_name
                    this.lastName = last_name
                    this.phones = phones
                    this.directions = directions

                })

            },

            updateAccess(){

                if(!this.$refs.form_access_account.validate())
                    return false

                this.setLoadingBtn()

                this.setUrl('buscar-cliente/1')

                this.requestApi({
                    method: 'PUT',
                    data: {
                        firstName: this.firstName,
                        lastName: this.lastName,
                        user: this.userAccount,
                        password: this.password,
                        oldUserAccount: this.oldUserAccount,
                        identification : this.identification,
                        typeUpdate: 'updateAccess'
                    }
                }).then(res=>{
                    console.log(res)
                    
                    this.alertNotification({
                        param:{
                            html : res.data.res.msg
                        }
                    })

                    let user = JSON.parse(localStorage.getItem('user'))
                    user.user_ligin_id = this.userAccount
                    user.identification = this.identification
                    user.name = this.firstName+' '+this.lastName
                    localStorage.setItem('user',JSON.stringify(user))
                    this.checkSessionStatus()

                }).catch(err=>{
                    console.log(err)
                }).then(()=>{

                    this.setLoadingBtn()

                })

            },

            addPhone(){

                this.phones.unshift({
                    phone: null,
                    contact_mech_id:null
                })

            },

            storePhones(){

                let valid = true

                for (let index = 0; index < this.$refs.form_phone.length; index++) {
                    valid = this.$refs.form_phone[index].validate()
                    if(!valid)  return false
                }

                if(valid){
                  
                    this.setLoadingBtn()

                    this.setUrl('buscar-cliente/1')

                    this.requestApi({
                        method: 'PUT',
                        data: {
                            phones: this.phones,
                            partyId: this.user.party_id,
                            typeUpdate: 'updatePhones'
                        }
                    }).then(res=>{
                        console.log(res)
                        this.getDataCustomer()
                        this.alertNotification({
                            param:{
                                html : res.data.res.msg
                            }
                        })

                    }).catch(err=>{
                        console.log(err)
                    }).then(()=>{

                        this.setLoadingBtn()

                    })

                }
            },

            deletePhones(phone){

                if(phone.contact_mech_id != null){

                    this.removePhone(phone)

                }else{

                    let index = this.phones.indexOf(phone)
                    this.phones.splice(index,1)

                }

            },

            removePhone(phone){

                Vue.swal({
                    html: `¿Está seguro de eliminar el teléfono?`,
                    icon: 'warning',
                    ...this.paramAlertQuestion
                }).then((result) => {

                    if (result.isConfirmed) {

                        this.overlay=true
                        this.setUrl('buscar-cliente/1')

                        this.requestApi({
                            method: 'PUT',
                            data: {
                                contactMechId: phone.contact_mech_id,
                                partyId: this.user.party_id,
                                typeUpdate: 'deletePhone'
                            }
                        }).then(res=>{
                            console.log(res)

                            let index = this.phones.indexOf(phone)
                            this.phones.splice(index,1)
                            this.overlay=false
                            
                            this.alertNotification({
                                param:{
                                    html : res.data.res.msg
                                }
                            })

                        }).catch(err=>{

                            console.log(err)
                            this.overlay=false

                        }).then(()=>{

                            this.overlay=false

                        })

                    }
                })

            },

            addDirection(){

                this.contactMechDirectionId=null
                this.dialogNewDirection= true

            },

            storeDirection(data){
               
                this.setUrl('buscar-cliente/1')
                this.overlay=true
                
                const {
                    province, 
                    provinceName, 
                    reference, 
                    secondaryStreet, 
                    sector, 
                    state, 
                    street
                } = data

                this.requestApi({
                    method: 'PUT',
                    data:{
                        contactMechDirectionId: this.contactMechDirectionId,
                        partyId: this.user.party_id,
                        province,
                        parroquiaId: state.parroquia_id,
                        provinciaId: state.provincia_id,
                        cantonId: state.canton_id,
                        street,
                        street2: secondaryStreet,
                        sector,
                        reference,
                        city: state.parroquia,
                        typeUpdate: 'storeDirections'
                    }
                }).then(res => {
                    
                    this.dialogNewDirection=false

                    if(this.contactMechDirectionId == null){
                        const {
                            address1,
                            calle_secundaria,
                            city,
                            contact_mech_id,
                            reference,
                            sector,
                            direction,
                            geo_id
                        } = res.data.res

                        this.directions.push({
                            address1,
                            calle_secundaria,
                            city,
                            contact_mech_id,
                            geo_id: geo_id,
                            observaciones: reference,
                            sector,
                            direction
                        })
                    }

                    this.overlay=false
                    this.alertNotification({
                        param:{
                            html : res.data.res.msg
                        }
                    })
                }).catch(err =>{
                    console.log(err)
                    this.overlay=false
                }).then(()=>{
                    this.overlay=false
                })

            },

            deleteDirection(direction){

                Vue.swal({
                    html: `¿Está seguro de eliminar la direccion?`,
                    icon: 'warning',
                    ...this.paramAlertQuestion
                }).then((result) => {

                    if (result.isConfirmed) {

                        this.overlay=true
                        this.setUrl('buscar-cliente/1')

                        this.requestApi({
                            method: 'PUT',
                            data: {
                                contactMechId: direction.contact_mech_id,
                                partyId: this.user.party_id,
                                typeUpdate: 'deleteDirection'
                            }
                        }).then(res=>{
                            console.log(res)

                            let index = this.directions.indexOf(direction)
                            this.directions.splice(index,1)
                            this.overlay=false
                            
                            this.alertNotification({
                                param:{
                                    html : res.data.res.msg
                                }
                            })

                        }).catch(err=>{

                            console.log(err)
                            this.overlay=false

                        }).then(()=>{

                            this.overlay=false

                        })

                    }
                })

            },

            editDirection(direction){
              
                this.contactMechDirectionId= direction.contact_mech_id
                this.dataDirection=direction
                this.dialogNewDirection = true
            },

            closeModalDirection(){

                this.dataDirection=null
                this.dialogNewDirection= false


            }

        },
        created(){

            this.getDataCustomer()
            console.log(this.user)

        }


    }
</script>